<template>
    <v-btn
        text
        @click="logout"
        >
        <v-icon class="mr-1">mdi-logout-variant</v-icon>
        <span>ログアウト</span>
    </v-btn>
</template>

<script>
export default {
    name: 'LogoutButton',
    methods: {
        logout: function(){
            this.$auth.logout();
        }
    }
}
</script>
